import { FC, PropsWithChildren } from 'react';

export const DropdownMenu: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex max-h-60 select-none flex-col overflow-y-auto overscroll-contain rounded-[4px] border border-white-4 bg-dark-green-950 text-label-regular text-white">
      {children}
    </div>
  );
};
